/**
 * app-bar.js
 */

import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import {
  AppBar,
  Toolbar,
  Box,
  Typography
} from '@mui/material';
import { Types } from 'utils/constants';


const useStyles = makeStyles(theme => ({
  appBar: {
    boxShadow: 'none',
    backgroundColor: props => {
      if (props.recordGroupType === Types.RecordGroup.TRAINING) {
        return theme.palette.comp.recordRow.event.background;
      } else if (props.recordGroupType === Types.RecordGroup.DEPLOYMENT) {
        return theme.palette.comp.recordRow.deployment.background;
      } else if (props.recordGroupType === Types.RecordGroup.CLASS) {
        return theme.palette.comp.recordRow.class.background;
      } else if (props.recordGroupType === Types.RecordGroup.VET_VISIT) {
        return theme.palette.comp.recordRow.vet.background;
      }
      return theme.palette.comp.appBar.background;
    }
  },
  toolBar: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    '& > *': {
      flex: 1
    }
  },
  titleBox: {
    textAlign: 'center',
    '& > *': {
      whiteSpace: 'nowrap'
    }
  },
  title: {
    textTransform: 'uppercase',
    fontSize: theme.typography.subtitle1.fontSize,
  },
  actionsLeft: {
    '& > *': {
      marginRight: theme.spacing(2)
    }
  },
  actionsRight: {
    '& > *': {
      marginLeft: theme.spacing(2)
    }
  }
}));


export default function PTAppBar(props) {
  const {
    leftActions,
    rightActions,
    title,
    recordGroupType,
    ...rest
  } = props;
  const classes = useStyles({ recordGroupType });

  return (
    <>
      <AppBar position="relative" className={classes.appBar} {...rest}>
        <Toolbar className={classes.toolBar}>
          <Box>
            {leftActions}
          </Box>
          <Box className={classes.titleBox}>
            <Typography
              variant="h6"
              className={classes.title}
              data-testid='appbar-title'
            >
              {title}
            </Typography>
          </Box>
          <Box display="flex" justifyContent="flex-end" className={classes.actionsRight}>
            {rightActions}
          </Box>
        </Toolbar>
      </AppBar>
    </>
  );
}